import React, {useEffect, useState} from 'react';
import {Button, Col, Form, Modal, Row} from 'react-bootstrap';
import {BiEdit, BiTrash} from 'react-icons/bi';
import {Get, Post} from '../../lib/Request';
import {ALERT_VARIANT} from '../../const/dataEnum';
import {setAlert} from '../../stores/actions/alertModalStateAction';
import {useDispatch} from 'react-redux';
import {API_ACTION, API_PROJECT} from '../../const/Api';
import {FmlxTable} from 'fmlx-common-ui';
import './ManageProjects.scss';

export default function ManageProjects() {
  const dispatch = useDispatch();

  const defaultProject = {id: 0, projectName: ''};

  // Project
  const [loadingProjects, setLoadingProjects] = useState(true);
  const [projects, setProjects] = useState([]);
  const [projectName, setProjectName] = useState('');
  const [projectID, setProjectID] = useState(0);

  const [action, setAction] = useState('');
  const [loadingModify, setLoadingModify] = useState(false);

  async function fetchProjects() {
    setLoadingProjects(true);
    let result = await Get(API_PROJECT);
    if (!callError(result)) {
      setProjects(result.data);
    } else {
      setProjects([]);
    }
    setLoadingProjects(false);
  }

  useEffect(() => {
    fetchProjects();
  }, []);

  function callError(result) {
    if (result.responseCode !== 0) {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: result.message}));
      return true;
    }
    return false;
  }

  function validateEntry() {
    return projectName.length > 0;
  }

  async function ModifyProject(event) {
    event.preventDefault();
    setLoadingModify(true);

    let param = {...defaultProject};
    let url;
    switch (action) {
      case 'Create':
        param.projectName = projectName;
        url = API_PROJECT + API_ACTION.CREATE;
        break;
      case 'Update':
        param.projectName = projectName;
        param.id = projectID;
        url = API_PROJECT + API_ACTION.UPDATE;
        break;
      case 'Delete':
        param.id = projectID;
        url = API_PROJECT + API_ACTION.DELETE;
        break;
      default:
        break;
    }
    let result = await Post(url, param);
    if (!callError(result)) {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.SUCCESS, message: result.message}));
      await fetchProjects();
    } else {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: result.message}));
    }
    setAction('');
    setProjectID(defaultProject.id);
    setProjectName(defaultProject.projectName);
    setLoadingModify(false);
  }

  const deletePrompt = (
    <Modal show={action === 'Delete'} centered size="md" aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header>
        <Modal.Title>Delete Project</Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure to delete this project?</Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={ModifyProject} disabled={loadingModify}>
          {loadingModify ? (
            <div>
              <span
                style={{marginLeft: '0px'}}
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            </div>
          ) : (
            'Yes'
          )}
        </Button>
        <Button
          variant="secondary"
          onClick={() => {
            setAction('');
            setProjectID(0);
          }}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );

  const createOrUpdatePrompt = (
    <Modal
      show={['Create', 'Update'].includes(action)}
      centered
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Form onSubmit={ModifyProject}>
        <Modal.Header>
          <Modal.Title>{action} Project</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row g-3>
            <Col>
              <Form.Group size="lg" controlId="username" className="mb-2">
                <Form.Label>Project Name</Form.Label>
                <Form.Control
                  autoFocus
                  placeholder="Project"
                  type="text"
                  value={projectName}
                  onChange={(e) => setProjectName(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button size="md" type="submit" style={{width: '150px'}} disabled={!validateEntry() || loadingModify}>
            {loadingModify ? (
              <div>
                <span
                  style={{marginLeft: '0px'}}
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              </div>
            ) : (
              'Save Changes'
            )}
          </Button>

          <Button
            variant="secondary"
            onClick={() => {
              setAction('');
              setProjectID(projectID);
              setProjectName(projectName);
            }}
            disabled={loadingModify}
          >
            Close
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );

  const getSelectedRow = (selectedItems) => {
    if (selectedItems.length > 0) {
      setProjectID(selectedItems[0].id);
      setProjectName(selectedItems[0].projectName);
    }
  };

  return (
    <div className="manage-project-container">
      <div className="manage-project">
        <div className="manage-project--button-container">
          <Button onClick={() => setAction('Create')}>Add Project</Button>
        </div>
        <div className="manage-project--table-container">
          <FmlxTable
            data={projects}
            getSelectedRow={getSelectedRow}
            isLoading={loadingProjects}
            columns={[
              {
                Header: 'No',
                accessor: null,
                editable: false,
                disableSort: true,
                hideSort: true,
                hideFilter: true,
                headerStyle: {
                  width: '10%',
                  minWidth: '10%',
                  maxWidth: '10%',
                },
                Cell: ({value, row}) => {
                  return <>{row.index + 1}</>;
                },
              },
              {
                Header: 'Project',
                accessor: 'projectName',
                editable: false,
                disableSort: true,
                hideSort: true,
                hideFilter: true,
                headerStyle: {
                  width: '70%',
                  minWidth: '70%',
                  maxWidth: '70%',
                },
              },
              {
                Header: 'Action',
                accessor: null,
                editable: false,
                disableSort: true,
                hideSort: true,
                hideFilter: true,
                headerStyle: {
                  width: '20%',
                  minWidth: '20%',
                  maxWidth: '20%',
                },
                Cell: ({value, row}) => {
                  return (
                    <div style={{display: 'flex', gap: '8px'}}>
                      <Button
                        onClick={() => {
                          setProjectID(row.original.id);
                          setProjectName(row.original.projectName);
                          setAction('Update');
                        }}
                      >
                        <BiEdit/>
                      </Button>
                      <Button
                        variant="danger"
                        onClick={() => {
                          setProjectID(projectID);
                          setProjectName(projectName);
                          setAction('Delete');
                        }}
                      >
                        <BiTrash/>
                      </Button>
                    </div>
                  );
                },
              },
            ]}
          />
        </div>
      </div>
      {deletePrompt}
      {createOrUpdatePrompt}
    </div>
  );
}
